// frontend/src/services/showcaseApi.ts
import api from './api';
import type { ApiResponse } from '@/types';
import type { ShowcaseCard, AdminSubmission } from '@/types/showcase';

// Public (unauthenticated) album showcase.
export const showcaseAPI = {
  list: async (params?: {
    page?: number;
    limit?: number;
  }): Promise<ApiResponse<ShowcaseCard[]>> => {
    const response = await api.get('/showcase', { params });
    return response.data;
  },
};

// Admin moderation (admin role required by the backend).
export const adminShowcaseAPI = {
  listPending: async (): Promise<ApiResponse<AdminSubmission[]>> => {
    const response = await api.get('/admin/showcase/submissions', {
      params: { status: 'pending' },
    });
    return response.data;
  },

  approve: async (eventId: string): Promise<ApiResponse<AdminSubmission>> => {
    const response = await api.post(`/admin/showcase/${eventId}/approve`);
    return response.data;
  },

  reject: async (eventId: string, reason: string): Promise<ApiResponse<AdminSubmission>> => {
    const response = await api.post(`/admin/showcase/${eventId}/reject`, { reason });
    return response.data;
  },
};
